var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteCatSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.906 34.2798C41.3842 40.6704 35.052 44.9025 27.6387 44.9025C21.2478 44.9025 14.141 40.8036 11.6192 34.413L11.5308 34.1938C10.7306 32.1893 10.8597 29.7358 10.8597 27.4419L13.4301 4.75101L20.5996 11.8166C22.6482 10.942 24.9014 10.4576 27.2659 10.4576H28.0114C30.3759 10.4576 32.6291 10.942 34.6777 11.8166L42.5482 4.05005L45.1574 27.7956C45.1574 30.0895 44.717 32.2796 43.9162 34.2841",
    fill: "#F4AA41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6387 44.9025C35.075 45.1426 41.9061 40.694 44.4279 34.3035L44.5056 34.1416C45.3057 32.137 45.177 29.3074 45.177 27.0135L42.5482 4.05005",
    fill: "#E27022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8999 38.2849L39.3389 34.6399",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9838 41.9299L36.4229 38.2849",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7568 33.9892C10.9736 32.0507 10.543 29.9327 10.543 27.7144L13.0945 4.75098L20.7909 12.2617C22.7943 11.4159 24.9976 10.9475 27.3099 10.9475H28.0389C30.3512 10.9475 32.5546 11.4159 34.5579 12.2617L42.2544 4.75105L44.8059 27.7145C44.8059 29.9328 44.3752 32.0508 43.5921 33.9893",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4404 41.9456C21.014 43.5531 24.0539 44.4813 27.3109 44.4813H28.0399C31.2969 44.4813 34.3381 43.5531 36.9103 41.9456",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4502 38.2849L16.0112 34.6399",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3662 41.9299L18.9272 38.2849",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1616 27.6087C38.9746 24.6928 34.6006 24.6928 33.1426 27.6087",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1885 27.6087C16.3755 24.6928 20.7495 24.6928 22.2075 27.6087",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4277 33.7452C27.4277 33.7452 35.1003 36.0748 27.4277 37.8011C27.4277 37.8011 35.0514 39.9796 27.4277 41.3823",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8253 33.6001C31.5592 33.6001 31.1253 33.0001 31.3503 32.5501C31.5753 33.0001 31.5753 32.1001 31.3503 32.5501C30.9003 31.6501 30.4503 31.7251 30.4503 31.7251C30.769 31.0501 28.3503 32.25 29.1003 31.05C29.1003 31.05 27.3753 29.625 27.6753 30.45C27.8253 29.775 25.6504 31.0501 24.3003 31.0501C22.7253 33.3751 22.4253 33.0751 21.6003 35.7751C21.6003 32.4751 22.0502 33.8251 21.7502 33.0751C21.3752 32.0251 22.5002 35.0147 21.7502 35.3147C21.0752 35.6147 20.8503 37.8001 20.8502 39.8251C21.0752 42.0751 20.4003 41.5501 20.8503 42.5251C21.9003 44.6251 20.4753 44.5501 20.4753 44.5501L19.4253 48.9751L26.7753 49.5001C26.8503 48.4501 26.7753 47.4001 27.0753 46.3501C27.3753 45.2251 28.3503 45.2251 29.1003 44.0251C30.9003 41.0251 30.8253 39.3751 31.7253 36.9751C31.8003 36.6751 31.9503 36.4501 32.1003 36.1501C32.4003 35.5501 32.4753 34.8001 32.1753 34.2001C31.7253 33.8251 31.5003 33.2251 30.8253 33.6001Z",
    fill: "#E27022"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7954 49.3907C20.2454 47.1407 20.6204 45.4907 20.7704 44.8157C20.4704 44.2157 20.7704 33.8657 21.6003 33.8658C24.3003 27.7907 32.0954 31.725 32.1704 34.5408C32.4704 35.2158 32.4704 35.9657 32.0954 36.6407L31.4204 37.9157C31.1954 38.5907 31.0454 39.2657 30.8954 39.8657C30.5954 41.5157 29.9954 43.0907 29.1704 44.5907C28.8704 45.1157 28.5704 45.5657 28.1204 45.8657C27.8204 46.1657 27.5954 46.3157 27.5204 46.6157C27.3704 47.5157 27.1454 48.7157 27.0704 49.9157",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1758 34.5832C25.2631 34.8451 25.5463 34.9867 25.8082 34.8994C26.0702 34.8121 26.2118 34.5289 26.1245 34.2669L25.1758 34.5832ZM27.2008 35.2582C27.2882 35.5201 27.5713 35.6617 27.8333 35.5744C28.0953 35.4871 28.2368 35.2039 28.1495 34.9419L27.2008 35.2582ZM25.9714 30.6965C25.4263 31.2415 24.5603 32.7367 25.1758 34.5832L26.1245 34.2669C25.6599 32.8734 26.3235 31.7586 26.6785 31.4036L25.9714 30.6965ZM28.6714 30.6965C28.403 30.9649 27.8973 31.6216 27.525 32.4264C27.1567 33.2224 26.8708 34.2679 27.2008 35.2582L28.1495 34.9419C27.9396 34.3122 28.1035 33.5576 28.4326 32.8462C28.7577 32.1435 29.1969 31.5852 29.3785 31.4036L28.6714 30.6965Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteCatSmall);
export default __webpack_public_path__ + "static/media/muteCatSmall.18daf78ca59a0cada39cacafa984fd22.svg";
export { ForwardRef as ReactComponent };